import React from 'react'
import { createUseStyles } from 'react-jss'

import Stack from 'components/base/Stack'

const useStyles = createUseStyles(({ colors, zIndexes }) => ({
  footer: {
    borderTop: `1px solid ${colors.greyExtraLight}`,
    display: ({ inline }) => (inline ? 'inline' : 'flex'),
    justifyContent: ({ inline }) => !inline && 'flex-end',
    margin: [10, -50, 0, -50],
    padding: [25, 50],
    paddingBottom: ({ fixed }) => !fixed && 0,
    position: ({ fixed }) => (fixed ? 'fixed' : 'initial'),
    left: ({ fixed }) => fixed && 50,
    bottom: ({ fixed }) => fixed && 0,
    background: colors.light,
    width: ({ fixed }) => fixed && '100%',
    zIndex: zIndexes.footer,
    borderRadius: '0 0 40px 40px'
  }
}))

function ModalFormFooter({
  children,
  fixed,
  justify,
  inline,
  className
}) {
  const classes = useStyles({ fixed, inline })

  return (
    <footer className={`${classes.footer} ${className || ''}`}>
      <Stack justify={justify}>{children}</Stack>
    </footer>
  )
}

export default ModalFormFooter
